// extracted by mini-css-extract-plugin
export var modalFooter = "_p8-0";